import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../Contexts/auth";
import "./style.css";

const FormLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { authenticated, login } = useContext(AuthContext);
    const [authorizedError, setAuthorizedError] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        await login(email, password);
        validateReturnLogin();
    };

    useEffect(() => {
        if (authorizedError) {
            setTimeout(() => {
                setAuthorizedError(false)
            }, 5000)
        }
    }, [authorizedError])


    function validateReturnLogin() {
        if (!authenticated) {
            setAuthorizedError(true);
        } else {
            setAuthorizedError(false);
        }
    }

    return (
        <div id="login">
            <div id="site-description">
                <h1 style={{ marginBottom: '0px' }}>Redech</h1>
                <div className="site-description-link">
                    <p>
                        <a
                            onClick={() => navigate("/")}
                            className="site-description-link"
                            style={{ fontSize: '15px', cursor: 'pointer' }}
                        >
                            Conheça o sistema Redech!
                        </a>
                    </p>

                </div>
            </div>
            <form className="form" onSubmit={handleSubmit}>
                <div className="field">
                    <input placeholder="Email" type="email" name="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className="field">
                    <input placeholder="Senha" type="password" name="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
                <div id="response-login" style={{ height: '22px' }}>
                    {authorizedError && <span className="form-field-error-password">{"E-mail ou senha inválidos"}</span>}
                </div>
                <div className="actions">
                    <button className="button-login" type="submit">Entrar</button>
                </div>
            </form>
            <div id="changePassword">
                <button onClick={() => navigate("/forgot-password")} className="changePassword">Esqueceu a senha?</button>
            </div>
            {/*<div id="login-or">
                <hr className="hr-or"></hr>
                <span className="span-or">ou</span>
            </div>
            <div className="actions">
                <button onClick={() => navigate("/create-account")} className="button-create" type="button">Criar nova conta</button>
            </div>*/}
        </div>
    );
}

export default FormLogin;
